import React from 'react'

const Skills = () => {
  return (
    <div id="skills" className="main font-vic text-white w-full h-full py-6 md:py-10">
        <div className="container mx-auto w-full justify-center items-center flex flex-col  gap-4">
        <div className="flex flex-col w-full md:w-[80%] h-full">
        <div className="flex flex-col  w-full h-full gap-3 py-4">
            <p className="text-gray-600 text-[12px] md:text-[20px] font-semibold tracking-widest"> TECH SKILLS</p>
        </div>
        </div>

          <div className="flex justify-center items-center">

             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
              
             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             
             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             <p className='absolute top-60 left-0 slide-in-paragraph'>Git</p>
              <p className='absolute top-60 right-0 slide-in-paragraph'>css</p>

             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             <p className='absolute top-0 left-0 slide-in-paragraph'>React</p>
              <p className='absolute top-0 right-0 slide-in-paragraph'>Next Js</p>
             {/* <p>Javascript</p> */}
             <p className='absolute bottom-0 left-0 slide-in-paragraph'>Django</p>
              <p className='absolute bottom-0 right-0 slide-in-paragraph'>Python</p>

             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             <p className='absolute top-0 left-0 slide-in-paragraph'>Javascript</p>
              <p className='absolute top-0 right-0 slide-in-paragraph'>Typescript</p>
             {/* <p>Typescript</p> */}

             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             
             <p className='absolute bottom-0 left-0 slide-in-paragraph'>Docker</p>
              <p className='absolute bottom-0 right-0 slide-in-paragraph'>MySql</p>

             <div className="border border-b rounded-full border-white p-5 md:p-14 relative h-full w-full">
             <p className='absolute bottom-10 md:bottom-0 left-0 slide-in-paragraph'>Firebase</p>
              <p className='absolute bottom-0 right-0 slide-in-paragraph'>Postgresql</p>

              <p className='absolute top-0 left-0 slide-in-paragraph'>HTML</p>
              <p className='absolute top-10 md:top-0 right-0 slide-in-paragraph'>Tailwind css</p>

             <div className="border border-b rounded-full border-white p-14 relative h-full w-full"></div>

             </div>

             </div>
             

             </div>

             </div>

             </div>


             </div>

             </div>



          </div>
        </div>
    </div>
  )
}

export default Skills